module.exports = __webpack_public_path__ + "static/img/2011.ce4933f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2011.jpg
// module id = 302
// module chunks = 0